import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Card, Form, Input, Button, Alert } from 'antd';
import { UserOutlined, LockOutlined, MedicineBoxOutlined } from '@ant-design/icons';
import { useAuth } from '../../../contexts/AuthContext.jsx';
import { toast } from '../../../utils/toast.js';

export function LoginPage() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const onFinish = async (values) => {
    setLoading(true);
    setErrorMsg('');
    try {
      const loggedInUser = await login(values);
      toast.success(`Chào mừng trở lại, ${loggedInUser.fullName || loggedInUser.email}!`);

      // Phân luồng chuyển trang theo vai trò:
      // Admin/Giảng viên vào thẳng Trang Quản Trị Hệ Thống (/admin)
      // Học viên vào Trang Khóa Học (/courses)
      if (loggedInUser.role === 'ADMIN' || loggedInUser.role === 'INSTRUCTOR') {
        navigate('/admin', { replace: true });
      } else {
        const from = location.state?.from?.pathname || '/courses';
        navigate(from, { replace: true });
      }
    } catch (err) {
      const msg = err.message || 'Đăng nhập không thành công. Vui lòng kiểm tra lại email/mật khẩu.';
      setErrorMsg(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: 'calc(100vh - 140px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 16px',
      }}
    >
      <Card
        style={{ width: '100%', maxWidth: 440, borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.06)' }}
        styles={{ body: { padding: '32px 28px' } }}
      >
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: 10,
              background: '#005537',
              color: '#fff',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 24,
              marginBottom: 12,
            }}
          >
            <MedicineBoxOutlined />
          </div>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: '#0f172a', marginBottom: 4 }}>
            Đăng Nhập PharmaLMS
          </h2>
          <p style={{ color: '#64748b', fontSize: 13 }}>
            Cổng đào tạo trực tuyến dành cho các Nhà thuốc & Quầy thuốc
          </p>
        </div>

        {errorMsg && (
          <Alert message={errorMsg} type="error" showIcon style={{ marginBottom: 16, fontSize: 13 }} />
        )}

        {/* Login Form */}
        <Form form={form} layout="vertical" onFinish={onFinish} requiredMark={false} size="large">
          <Form.Item
            label="Email đăng nhập"
            name="email"
            rules={[
              { required: true, message: 'Vui lòng nhập email' },
              { type: 'email', message: 'Email không đúng định dạng' },
            ]}
          >
            <Input prefix={<UserOutlined style={{ color: '#94a3b8' }} />} placeholder="admin@pharmalms.vn" />
          </Form.Item>

          <Form.Item
            label="Mật khẩu"
            name="password"
            rules={[{ required: true, message: 'Vui lòng nhập mật khẩu' }]}
          >
            <Input.Password prefix={<LockOutlined style={{ color: '#94a3b8' }} />} placeholder="••••••••" />
          </Form.Item>

          <Button type="primary" htmlType="submit" block loading={loading} style={{ height: 42, marginTop: 8 }}>
            Đăng Nhập
          </Button>
        </Form>

        <div style={{ textAlign: 'center', marginTop: 24, fontSize: 13, color: '#64748b' }}>
          Chưa có tài khoản học viên?{' '}
          <Link to="/register" style={{ color: '#0284c7', fontWeight: 600 }}>
            Đăng ký ngay
          </Link>
        </div>
      </Card>
    </div>
  );
}
